// extracted by mini-css-extract-plugin
export default {"header":"header-jzJPg","title":"title-xp9sz","backBtn":"backBtn-NKlPF"};